import {isObject, isArray} from '@config/utils';

export default {
    data() {
        return {

        }
    },
    computed: {
        itemData() {
            return this.data ? Object.entries(this.data).map(([key, value]) => {
                let items = value.items || {};
                if(isObject(items)) {
                    items = this.prepareItems(items);
                }else if (isArray(items)) {
                    let childs = [];
                    items.forEach(element => {
                        let child = element;
                        if(isObject(element)) {
                            child = this.prepareItems(element);
                        }
                        childs.push(child);
                    });
                    items = childs;
                }

                return {
                    name: value.name || key,
                    items: items
                };
            }) : [];
        },
    },
    methods: {
        prepareItems: function(items) {
            return Object.entries(items).map(([itemKey, itemValue]) => {
                let value = itemValue.value;
                let action = itemValue.action || null;
                if(itemValue.items) {
                    value = Object.entries(itemValue.items).map(([k, v]) => {
                        return v.value || v.name;
                    });
                }
                return {
                    name: itemValue.name,
                    value: value,
                    action: action,
                };
            });
        },
  },
};